<template>
  <v-main>
    <div class="max_width_container">
      <breadcrumbs class=" " :items="items"></breadcrumbs>
      <v-row cols="12" class="ma-0 pa-0 mt-2">
        <v-carousel
          :key="componentKey"
          style="height: 500px !important"
          eager
       >
        <v-carousel-item
            v-for="(image, i) in course.images"
            :key="i"
        >
          <div
              v-if="image.htmlEmbed"
              v-html="image.htmlEmbed"
          >
          </div>
          <v-img
              v-else
              class="carousel-item-img"
              :src="image.path"
              alt=""
              title=""
              height="100%"
              width="100%"
              cover
          ></v-img>
        </v-carousel-item>
      </v-carousel>
      </v-row>
      <v-row cols="12" class="ma-0 pa-0 mt-5" v-if="course && course.id">
        <h1 class="text-title-section">{{ course.name }}</h1>
      </v-row>
      <v-row cols="12" class="ma-0 pa-0 mt-5">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <h3 class="text-title-section">Sobre o Curso</h3>
        </v-col>

        <v-col class="ma-0 pa-0 mt-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <section v-html="course.aboutTheCourse"></section>
        </v-col>
      </v-row>

      <v-row cols="12" class="ma-0 pa-0 mt-3" v-if="course && course.skillsAcquired && course.skillsAcquired.length > 0">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <h3 class="text-title-section">Suas habilidades ao final do curso</h3>
        </v-col>

        <v-col
            class="ma-0 pa-0 mt-0 pr-3 pb-1"
            style="margin-top: -20px!important;"
            cols="12" xs="12" sm="6" md="6" lg="6" xl="4"
            v-for="item in course.skillsAcquired"
            :key="item.id"
        >
          <v-card
              elevation="1"
              class="pa-2 flex-column"
              style="border-radius: 10px"
              height="80%"
              color="#F8F9FD"
          >
            <p class="mb-2">
              <strong v-html="item.title"></strong>
            </p>
            <v-divider></v-divider>
            <p class="mt-2">
              <span v-html="item.description"></span>
            </p>
          </v-card>
        </v-col>
      </v-row>


      <v-row cols="12" class="ma-0 pa-0 mt-10" v-if="course && course.targetAudiences && course.targetAudiences.length > 0">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <h3 class="text-title-section">Este curso é para você que:</h3>
        </v-col>

        <v-col
            class="ma-0 pa-0 mt-0 pr-3 pb-1"
            style="margin-top: -20px!important;"
            cols="12" xs="12" sm="6" md="6" lg="6" xl="4"
            v-for="item in course.targetAudiences"
            :key="item.id"
        >
          <v-card
              elevation="1"
              class="pa-2 flex-column"
              style="border-radius: 10px"
              height="80%"
              color="#F8F9FD"
          >
            <p class="mb-2">
              <strong v-html="item.title"></strong>
            </p>
            <v-divider></v-divider>
            <p class="mt-2">
              <span v-html="item.description"></span>
            </p>
          </v-card>
        </v-col>
      </v-row>


      <v-row cols="12" class="ma-0 pa-0 mt-10" v-if="course && course.contentsProgrammatic && course.contentsProgrammatic.length > 0">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <h3 class="text-title-section">Conteúdo programático</h3>
        </v-col>

        <v-col class="ma-0 pa-0 mt-3" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-expansion-panels >
            <v-expansion-panel
                v-for="(item,i) in course.contentsProgrammatic"
                :key="i"
                class="pb-2 mb-2"
            >
              <v-expansion-panel-header class="ma-0 pa-0 px-2">
                <span style="font-size: 16px">{{ item.title }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="#F8F9FD">
                <span v-html="item.description"></span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row cols="12" class="ma-0 pa-0 mt-10" v-if="course && course.requirements">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <h3 class="text-title-section">Pré-requisitos</h3>
        </v-col>

        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <section v-html="course.requirements"></section>
        </v-col>
      </v-row>


      <v-row cols="12" class="ma-0 pa-0 mt-5" >
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-col class="ma-0 pa-0 text-center" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <h3 class="text-title-section">PRÓXIMAS TURMAS</h3>
          </v-col>
        </v-col>

        <v-col class="ma-0 pa-0 mt-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="courseGroups && courseGroups.length > 0">
          <CourseGroup
              :courseGroups="courseGroups"
          ></CourseGroup>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-center" v-else>
          <h2>Nenhum curso com inscrições abertas!</h2>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>


<script>
import ApiService from "../../../services/ApiService";
import Breadcrumbs from "../components/Breadcrumbs.vue";
import Utils from '../../../Utils/FormatDate';
import UtilsFormatCurrency from '../../../Utils/FormatCurrency';

import Vue from "vue";
import CourseGroup from "./CourseGroup.vue";

export default {
  name: "Category",
  components: {
    CourseGroup,
    Breadcrumbs,
  },

  async mounted() {
    const {name} = this.$route.params
    this.courseName = name
    await this.getCourse()
    await this.getCourseGroup()
    this.items = [
      {
        text: "Página Inicial",
        disabled: true,
        href: "/home",
      },
      {
        text: "Cursos",
        disabled: true,
        href: "",
      },
      {
        text: this.course.name,
        disabled: false,
        href: "",
      },
    ]
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, {passive: true});
    }
    this.$root.$off("rechargeSubcategory")
  },

  data: () => ({
    page: 1,
    totalPages: 15,
    totalItems: 0,
    componentKey: 1,
    isMobile: false,
    initalRange: 0,
    finalRange: 0,
    products: [],
    courses: [],
    course: [],
    subCategory: {},
    selected: null,
    env_url: "",
    apiService: new ApiService(),
    title: "",
    meta: [],
    filter: {
      page: 1,
      pageSize: 20,
      productSubCategory: null,
      CategoryName: null,
      productIndicator: null,
      rangePrice: [0, 200],
      product: "",
      selectedSizes: [],
      Subcategories: [],
      orderByPrice: 0,
    },
    items: [],
    loadingItems: false,
    headers: [
      {
        text: "Quando?",
        align: "start",
        value: "when",
        sortable: false,
      },
      {
        text: "Hora de término",
        align: "start",
        value: "endTime",
        sortable: false,
      },
      {
        text: "Data de início",
        align: "start",
        value: "startDate",
        sortable: false,
      },
      {
        text: "Data de término",
        align: "start",
        value: "endDate",
        sortable: false,
      },
      {
        text: "Nível",
        align: "start",
        value: "level",
        sortable: false,
      },
      {
        text: "Vagas",
        align: "start",
        value: "numberOfVacancies",
        sortable: false,
      },
      {
        text: "Ativo",
        align: "start",
        value: "active",
        sortable: false,
      },
      {
        text: "Ações",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    courseGroups: [],
    courseName: null,
    active: [
      {name: "Não", value: 'false'},
      {name: "Sim", value: true},
    ],
    periods: [
      {name: "Matutino", value: "0"},
      {name: "Vespertino", value: 1},
      {name: "Noturno", value: 2}
    ],
    levels: [
      {name: "Iniciante", value: "0"},
      {name: "Intermediário", value: 1},
      {name: "Avançado", value: 2}
    ],
    daysOfTheWeek: [
      {name: "Domingo", value: 0},
      {name: "Segunda-feira", value: 1},
      {name: "Terça-feira", value: 2},
      {name: "Quarta-feira", value: 3},
      {name: "Quinta-feira", value: 4},
      {name: "Sexta-feira", value: 5},
      {name: "Sábado", value: 6}
    ],
  }),


  computed: {},

  async created() {

  },

  watch: {},
  methods: {
    formatDate(date) {
      return Utils.momentDate(date);
    },
    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },
    async getCourse() {
      try {
        const {content} = await this.apiService.get(`course/linkSearch/${this.courseName}`)
        this.course = content
        if(this.course.videos && this.course.videos.length > 0) {
          this.course.videos.forEach((video) => {
            video.htmlEmbed = video.htmlEmbed
                .replace(/width="\d+"/, 'width="100%"')
                .replace(/height="\d+"/, 'height="500"')
          })
          this.course.images.push(...this.course.videos)
        }
      } catch (e) {

      }
    },
    async getCourseGroup() {
      try {
        const {content} = await this.apiService.get(`courseGroup/${this.course.id}/course`)
        this.courseGroups = content
      } catch (e) {

      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },


    async goTo(path) {
      await this.$router.push({
        path,
      });
    },
  },
};
</script>
<style scoped>
.text-title-section {
  color: #BC0000
}

.max_width_container {
  width: 80% !important;
  margin: 0 10% 0 10%;
}

@media (max-width: 1264px) {
  .max_width_container {
    width: 95% !important;
    margin: 0 2.5% 0 2.5%;
  }
}
</style>